import { createContext, useContext } from 'react';
import type { AccessInfo } from './api';

export interface BillingContextValue {
  accountId: string | null;
  access: AccessInfo | null;
  /** Re-fetch entitlement + free usage. */
  refresh: () => void;
  /** Open the upgrade (套餐) modal. */
  openBuy: () => void;
  /**
   * Meter one export/generation. Returns true if the action may proceed (and was
   * counted); false if the free quota is exhausted (the upgrade modal is opened).
   * Fails open on network errors so transient issues never block a paying user.
   */
  gate: () => Promise<boolean>;
}

export const BillingContext = createContext<BillingContextValue | null>(null);

export function useBilling(): BillingContextValue {
  const ctx = useContext(BillingContext);
  if (!ctx) throw new Error('useBilling must be used inside <BillingProvider>');
  return ctx;
}
